
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { updPrioritySalesOrders } from "@/api/api-basic";
import { optionKey, getOptionList } from "@/api/api-dict";
// import regular from "@/common/regular";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class ProductionOrderAdjustPriorities extends Vue {
  private formInline: objAny = {
    priority: "",
    projectNamePkId: "",
    contractBillNumber: "",
    sellerName: "",
    projectName: ""
  };
  private priorityList: object[] = [];
  private formObj: objAny = {};
  private ruleInline: objAny = {
    priority: [
      {
        required: true,
        message: i18n.t("productionOrder.priorityPl"),
        trigger: "change"
      }
    ]
  };
  private itemData: objAny = {};
  private modalShow = false;
  private loading = false;
  public open(item: objAny) {
    this.modalShow = true;
    this.itemData = item;
    this.formInline.projectNamePkId = item.projectNamePkId;
    this.formInline.priority = item.priority + "";
    this.formInline.contractBillNumber = item.contractBillNumber;
    this.formInline.sellerName = item.sellerName;
    this.formInline.projectName = item.projectName;
  }
  public handleSubmit() {
    this.formObj.validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      }
    });
  }
  async submitData(): Promise<void> {
    this.loading = true;
    const ret = await updPrioritySalesOrders(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.$emit("success");
      this.modalShow = false;
    }
    this.loading = false;
  }
  public handleReset() {
    this.formObj.resetFields();
  }
  async getOptionList() {
    const data = await getOptionList([optionKey.priority]);
    this.priorityList = data[optionKey.priority];
  }
  mounted() {
    this.getOptionList();
    this.$nextTick(() => {
      this.formObj = this.$refs["formValidate"];
    });
  }
}
